import StrUtils from '@/utils/StrUtils'

/**
 * 表单数据动态校验工具类
 */
export class DataCheckUtil {
  /**
   * 表单校验
   * @param $refs
   * @param data
   * @param view
   * @returns {boolean}
   */
  static checkForm(refs, data, view) {
    for (const ref in refs) {
      const valid = refs[ref].$attrs.valid
      if (valid && this.verifyField(ref, data)) {
        const label = refs[ref].label
        view.$message.warning(valid + label)
        refs[ref].$el.getElementsByTagName('input')[0].focus()
        return true
      }
    }
    return false
  }

  /**
   * 校验数据是否为空
   * @param field
   * @param data
   * @returns {boolean|*}
   */
  static verifyField(field, data) {
    if (typeof data[field] === 'number') {
      return data[field] === 0
    }
    return StrUtils.isEmpty(data[field])
  }
}
